import axios from 'utils/axios';
import { useCallback, useEffect, useState } from 'react';
import { IUsers } from '../types/users.interface';
import { IUser } from 'types/user.interface';
import { ICustomQuestion } from 'types/program';
// import { UserRoleId } from '../types/user.interface';

export interface UseUsersState {
    users: IUsers;
    fetchInProgress: boolean
    setProfileTagsInProgress: boolean
    ready: boolean
    error: string
}

export const useUsers = (
    role?: string,
    // region?: IRegionId,
    active?: boolean
) => {
    const [state, setState] = useState<UseUsersState>({
        ready: false,
        fetchInProgress: false,
        setProfileTagsInProgress: false,
        users: null,
        error: null
    });

    const fetch = useCallback(async () => {
        setState(s => ({ ...s, fetchInProgress: true }));

        await axios.get<any>(
          role === "Super Admin" ?
            (active === false ? '/berryAPI/superadmin/archivedSuperAdmins' : '/berryAPI/superadmin/superAdmins')
            : (active === false ? '/berryAPI/users/archivedusers' : '/berryAPI/users'),
          {
          params: {
            role
          }
        })
        .then((response) => {
          setState(s => ({
            ...s,
            fetchInProgress: false,
            ready: true,
            users: response.data.users,
            error: response.data.error
          }))
        })
        .catch((error) => {
          console.error('Error fetching users:', error);
          setState(s => ({...s, error: error}));
        });
      }, [setState])
      
      //Set profile tags for multiple users
      const setProfileTags = useCallback(
      async (data: any) => {
        setState(s => ({ ...s, setProfileTagsInProgress: true }))

        await axios.post('/berryAPI/users/setProfileTags', data, {});
        setState(s => ({ ...s, setProfileTagsInProgress: false }))
        await fetch(); //to refresh users
      }, [setState])

      //leaving code below for when need to deal with restoring users etc
    // useEffect(() => {
    //     (async () => {
    //         const params: { [key: string]: any } = {};
    //         if (role) {
    //             params.role = role;
    //         }
    //         // if (region) { params.region = region }
    //         var response: any;
    //         if (!deleted) {
    //             response = await axios.get('/berryAPI/users', {
    //                 // headers: { Authorization: `Bearer ${APP_INIT.apiToken}` },
    //                 params: params
    //             });
    //         } else {
    //             response = await axios.get('/berryAPI/deletedUsers', {
    //                 // headers: { Authorization: `Bearer ${APP_INIT.apiToken}` },
    //                 params: params
    //             });
    //         }

            // const deleteUser = async (userID: IUserId) => {
            //   setState(s => ({ ...s, deleteUserInProgress: true }))
            //   const updateResponse = await axios.delete(
            //     `/v2/users/${userID}`,
            //     {
            //       // headers: { Authorization: `Bearer ${APP_INIT.apiToken}` },
            //     },
            //   )
            //   setState(s => ({
            //     ...s,
            //     deleteUserInProgress: false,
            //     users: updateResponse.data.users,
            //   }))
            // }

            // const restoreUser = async (userID: IUserId) => {
            //   setState(s => ({ ...s, restoreUserInProgress: true }))
            //   const updateResponse = await axios.delete(
            //     `/v2/deletedUsers/${userID}`,
            //     {
            //       headers: { Authorization: `Bearer ${APP_INIT.apiToken}` },
            //     },
            //   )
            //   setState(s => ({
            //     ...s,
            //     restoreUserInProgress: false,
            //     users: updateResponse.data.users,
            //   }))
            // }

            // const approveUser = async (userID: IUserId) => {
            //   setState(s => ({ ...s, approveUserInProgress: true }))
            //   const updateResponse = await axios.post(
            //     `/v2/approveUser/${userID}`,
            //     {
            //       headers: { Authorization: `Bearer ${APP_INIT.apiToken}` },
            //     },
            //   )
            //   setState(s => ({
            //     ...s,
            //     approveUserInProgress: false,
            //     users: updateResponse.data.users,
            //   }))
            // }

    //         setState({
    //             ready: true,
    //             users: response.data.users
    //             // regions: response.data.regions,
    //             // deleteUserInProgress: false,
    //             // deleteUser,
    //             // restoreUserInProgress: false,
    //             // restoreUser,
    //             // approveUserInProgress: false,
    //             // approveUser,
    //         });
    //     })();
    // }, [
    //     role,
    //     deleted
    //     //  region
    // ]);

    useEffect(() => {
        fetch()
      }, [])
      return { ...state, fetch, setProfileTags }
    };


  export interface UseDeliveryDriversState {
    deliveryDrivers: IUsers;
    fetchInProgress: boolean
    ready: boolean
  }
    /**
   * Get delivery drivers for routes. Used when displaying routes and editing a route.
   *
   * @return JsonResponse delivery drivers.
   */
  export const useDeliveryDrivers = (
      includeInactive?: boolean
  ) => {
      const [state, setState] = useState<UseDeliveryDriversState>({
          ready: false,
          fetchInProgress: false,
          deliveryDrivers: null
      });
  
      const fetchDeliveryDrivers = useCallback(async () => {
          setState(s => ({ ...s, fetchInProgress: true }));
  
          const response = await axios.get<any>('/berryAPI/users/deliveryDrivers', {
            params: {
              includeInactive: includeInactive
            }
          });
          setState(s => ({
            ...s,
            fetchInProgress: false,
            ready: true,
            deliveryDrivers: response.data
          }))
        }, [setState])
  
      useEffect(() => {
          fetchDeliveryDrivers()
        }, [])
        return { ...state, fetchDeliveryDrivers }
      };


    export interface UseFoodDonorsState {
        foodDonors: IUsers;
        fetchInProgress: boolean
        ready: boolean
    }
    /**
     * Get food donors for routes. Used when editing a route.
     *
     * @return JsonResponse food donors.
     */
    export const useFoodDonors = (
        includeInactive?: boolean
    ) => {
        const [state, setState] = useState<UseFoodDonorsState>({
            ready: false,
            fetchInProgress: false,
            foodDonors: null
        });
    
        const fetchFoodDonors = useCallback(async () => {
            setState(s => ({ ...s, fetchInProgress: true }));
    
            const response = await axios.get<any>('/berryAPI/users/foodDonors', {
              params: {
                includeInactive: includeInactive
              }
            });
            setState(s => ({
              ...s,
              fetchInProgress: false,
              ready: true,
              foodDonors: response.data
            }))
          }, [setState])
    
        useEffect(() => {
            fetchFoodDonors()
          }, [])
          return { ...state, fetchFoodDonors }
        };


        
    export interface UseRecipientsState {
      recipients: IUsers;
      fetchInProgress: boolean
      ready: boolean
    }
    /**
     * Get recipients for routes. Used when editing a route.
     *
     * @return JsonResponse recipients.
     */
    export const useRecipients = (
        includeInactive?: boolean,
        withTimeAvailabilities?: boolean
    ) => {
        const [state, setState] = useState<UseRecipientsState>({
            ready: false,
            fetchInProgress: false,
            recipients: null
        });
      //TODO: SEE WHERE THIS IS BEING USED, MIGHT BE A DUPLICATE OF EXISITNG ENDPOINT
        const fetchRecipients = useCallback(async () => {
            setState(s => ({ ...s, fetchInProgress: true }));

            const response = await axios.get<any>('/berryAPI/users/recipients', {
              params: {
                includeInactive: includeInactive,
                withTimeAvailabilities: withTimeAvailabilities
              }
            });
            setState(s => ({
              ...s,
              fetchInProgress: false,
              ready: true,
              recipients: response.data
            }))
          }, [setState])
        useEffect(() => {
              fetchRecipients()
          }, [])
          return { ...state, fetchRecipients }
        };

      export interface UseRecipientApplicationsState {
        recipientApplications: IUser[];
        customFields: ICustomQuestion[];
        fetchInProgress: boolean
        ready: boolean
      }
       
      /**
       * Get recipient applications.
       *
       * @return JsonResponse recipient applications.
       */
      export const useRecipientApplications = (
          role?: string,
          // region?: IRegionId,
          active?: boolean
      ) => {
          const [state, setState] = useState<UseRecipientApplicationsState>({
              ready: false,
              fetchInProgress: false,
              recipientApplications: [],
              customFields: []
          });
      
          const fetchRecipientApplications = useCallback(async () => {
              setState(s => ({ ...s, fetchInProgress: true }));
      
              const response = await axios.get<any>('/berryAPI/users/recipientApplications', {
                params: {
                  role
                }
              });
              setState(s => ({
                ...s,
                fetchInProgress: false,
                ready: true,
                recipientApplications: response.data.applications || [],
                customFields: response.data.customFields || []
              }))
            }, [setState])
      
          useEffect(() => {
              fetchRecipientApplications()
            }, [])
            return { ...state, fetchRecipientApplications }
          };
    
      export interface UseDonorApplicationsState {
        donorApplications: IUser[];
        customFields: ICustomQuestion[];
        fetchInProgress: boolean
        ready: boolean
      }
      /**
       * Get donor applications.
       *
       * @return JsonResponse donor applications.
       */
      export const useDonorApplications = (
          role?: string,
          // region?: IRegionId,
          active?: boolean
      ) => {
          const [state, setState] = useState<UseDonorApplicationsState>({
              ready: false,
              fetchInProgress: false,
              donorApplications: [],
              customFields: []
          });
      
          const fetchDonorApplications = useCallback(async () => {
              setState(s => ({ ...s, fetchInProgress: true }));
      
              const response = await axios.get<any>('/berryAPI/users/donorApplications', {
                params: {
                  role
                }
              });
              setState(s => ({
                ...s,
                fetchInProgress: false,
                ready: true,
                donorApplications: response.data.applications || [],
                customFields: response.data.customFields || []
              }))
            }, [setState])
      
          useEffect(() => {
              fetchDonorApplications()
            }, [])
            return { ...state, fetchDonorApplications }
          };
          
          export interface UseDeliveryDriverApplicationsState {
            deliveryDriverApplications: IUser[];
            fetchInProgress: boolean;
            customFields: ICustomQuestion[];
            ready: boolean;
          }
           
          /**
           * Get delivery driver applications.
           *
           * @return JsonResponse delivery driver applications.
           */
          export const useDeliveryDriverApplications = (
              role?: string,
              // region?: IRegionId,
              active?: boolean
          ) => {
              const [state, setState] = useState<UseDeliveryDriverApplicationsState>({
                  ready: false,
                  fetchInProgress: false,
                  deliveryDriverApplications: [],
                  customFields: []
              });
          
              const fetchDeliveryDriverApplications = useCallback(async () => {
                  setState(s => ({ ...s, fetchInProgress: true }));
          
                  const response = await axios.get<any>('/berryAPI/users/deliveryDriverApplications', {
                    params: {
                      role
                    }
                  });
                  setState(s => ({
                    ...s,
                    fetchInProgress: false,
                    ready: true,
                    deliveryDriverApplications: response.data.applications || [],
                    customFields: response.data.customFields || []
                  }))
                }, [setState])
          
              useEffect(() => {
                  fetchDeliveryDriverApplications()
                }, [])
                return { ...state, fetchDeliveryDriverApplications }
              };
